import React from 'react';
import styles from './styles.scss';

function ProductLineup({ children }) {
  return (
    <div className="container-fluid main-container">
      <div className="row">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <div className={`${styles.tableRow} row`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductLineup;



// WEBPACK FOOTER //
// ./src/components/ProductLineup/index.js